import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const datepickerThemeToken: any = {
  //==================== ICON =============================/
  colorIcon: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorIconHover: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  iconSize: 20,

  //========================= SIZE =================================/
  controlHeight: 40,
  controlHeightLG: 48,
  controlHeightSM: 36,

  paddingBlock: 10,
  paddingBlockLG: 14,
  paddingBlockSM: 8,

  paddingInline: 10,
  paddingInlineLG: 10,
  paddingInlineSM: 8,
  cellHeight: 26,
  cellWidth: 38,

  //========================= FONT =================================/
  inputFontSize: variableTypography["BodyMediumFontSize"],
  inputFontSizeLG: variableTypography["BodyMediumFontSize"],
  inputFontSizeSM: variableTypography["BodySmallFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
  lineHeightLG: variableTypography["BodyMediumLineHeight"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  fontFamily: variableTypography["BodyMediumFontFamily"],

  //========================= EFFECTS =================================/
  activeShadow: "none",
  errorActiveShadow: "none",
  warningActiveShadow: "none",

  //========================= RANGE =================================/
  cellActiveWithRangeBg: variableColors["ColorFigmaComplementaryBlue10"],
  cellHoverWithRangeBg: variableColors["ColorFigmaComplementaryBlue10"],
  cellRangeBorderColor: variableColors["ColorFigmaComplementaryBlue10"],

  //========================= COLOR =================================/
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorTextPlaceholder: variableColors["ColorFigmaNeutralGrayscaleGray70"],

  //========================= BORDER =================================/
  borderRadiusSM: 2,
};
